/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'company-hub.carousel-extension.card-strip.card.label': 'snímek {positionInSet}/{setSize}',
  'company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title': 'Přidejte název',
  'company-hub.carousel-extension.carousel-navigation.pause': 'Pozastavit',
  'company-hub.carousel-extension.carousel-navigation.play': 'Přehrát',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.next': 'Další',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.previous': 'Předchozí',
  'company-hub.carousel-extension.config-panel.add-frame-cta': 'Přidat snímek',
  'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list': 'Přidat snímky',
  'company-hub.carousel-extension.config-panel.layout.title': 'Vyberte rozvržení',
  'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label': 'Text se snímkem nad obrázkem',
  'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label': 'Jednobarevné pozadí',
  'company-hub.carousel-extension.config-panel.layouts.split-design-content.label': 'Rozdělit návrh',
  'company-hub.carousel-extension.config-panel.link.field.label': 'Připojit',
  'company-hub.carousel-extension.config-panel.lozenge.label.updated': 'AKTUALIZOVÁNO',
  'company-hub.carousel-extension.config-panel.navigation.progress-circles': 'Kruhy průběhu',
  'company-hub.carousel-extension.config-panel.navigation.thumbnails': 'Miniatury',
  'company-hub.carousel-extension.config-panel.preamble-link.label-v2': 'Další informace o karuselech',
  'company-hub.carousel-extension.config-panel.preamble-v2':
    'Navrhněte sadu až {number} rotujících snímků. {supportLink}',
  'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link':
    'Navrhněte sadu až {number} rotujících snímků.',
  'company-hub.carousel-extension.config-panel.style.general.title': 'Obecné',
  'company-hub.carousel-extension.config-panel.style.navigation.title': 'Navigace',
  'company-hub.carousel-extension.config-panel.styles.autoplay-label': 'Automatické přehrávání',
  'company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content':
    'Nastavte, aby se karusel v režimu prohlížení automaticky posouval jednou za {number} s.',
  'company-hub.carousel-extension.config-panel.tab.content.label': 'Obsah',
  'company-hub.carousel-extension.config-panel.tab.styles.label': 'Styly',
  'company-hub.carousel-extension.config-panel.title': 'Karusel',
  'company-hub.carousel-extension.description.field.label': 'Popis',
  'company-hub.carousel-extension.description.placeholder': 'Přizpůsobte si tento snímek a vytvořte rotující karusel.',
  'company-hub.carousel-extension.frame-spotlight.label': 'snímek {positionInSet}/{setSize}',
  'company-hub.carousel-extension.frame.background.color': 'Barva pozadí',
  'company-hub.carousel-extension.frame.color-contrast.fail':
    'Vaše kombinace barev textu a pozadí neposkytuje dobrou čitelnost.',
  'company-hub.carousel-extension.frame.color-contrast.success':
    'Vaše kombinace barev textu a pozadí poskytuje dobrou čitelnost.',
  'company-hub.carousel-extension.frame.text.color': 'Barva textu',
  'company-hub.carousel-extension.hub-element.description': 'Rotující sada krásných snímků',
  'company-hub.carousel-extension.hub-element.title': 'Karusel',
  'company-hub.carousel-extension.manifest.macro-description': 'Vytvořte rotující trojici dynamických snímků.',
  'company-hub.carousel-extension.manifest.macro-title': 'Karusel',
  'company-hub.carousel-extension.manifest.macro-title.updated': 'Karusel [aktualizováno]',
  'company-hub.carousel-extension.placeholder.description': 'Přizpůsobte si tento snímek a vytvořte rotující karusel.',
  'company-hub.carousel-extension.placeholder.title': 'Dejte svému snímku název',
  'company-hub.carousel-extension.recommended.field.label': '(doporučeno)',
  'company-hub.carousel-extension.title.field.label': 'Název',
  'company-hub.carousel-extension.title.placeholder': 'Dejte svému snímku název',
};
